import { observer } from 'mobx-react-lite';
import React from 'react'
import { useStore } from '../../../../../../hooks/useStore';
import { createFacebookShareLink } from '../../../../../../utils/general';
import CircularButton from '../../../../../general/buttons/circular-button/CircularButton'
import { SmartLinkExternal} from '../../../../../general/link'

const ShareFacebookLink = observer(() => {
    const {uiStore: {home__share__activeOrg}} = useStore();
    const link = window.location.href + "share/" + home__share__activeOrg.slug;


    return (
        <SmartLinkExternal to={createFacebookShareLink(link)} action="Share to Facebook">
            <CircularButton noAction>
                <svg viewBox="0 0 276.79 512"><g><path d="M187.36,0c27,0,54,0,81,0,6.48,2.54,8.5,7.41,8.43,14.16-.23,23.66-.07,47.33-.1,70.99-.01,10.62-3.4,13.85-14.14,13.95-16.82,.16-33.67-.01-50.46,.89-5.71,.31-11.82,2.51-16.76,5.5-8.25,4.98-9.72,14.03-9.89,22.81-.35,17.82-.17,35.66-.2,53.49,0,.62,.21,1.24,.39,2.25,1.96,0,3.76,0,5.56,0,23,0,45.99-.02,68.99,.01,9.6,.01,13.33,3.72,13.34,13.29,.02,26.16,.01,52.33-.02,78.49-.01,9.69-3.58,13.23-13.29,13.24-23.16,.02-46.33,0-69.49,0h-5.51c0,2.96,0,5.12,0,7.28,0,66.99-.04,133.98,.06,200.98,.01,6.55-1.62,11.75-7.93,14.66H85.36c-6.28-2.51-8.24-7.24-8.22-13.83,.14-67.49,.08-134.97,.08-202.46,0-2.09,0-4.18,0-6.62-2.57,0-4.39,0-6.2,0-19.16,0-38.33,.02-57.49,0-9.98-.01-13.49-3.5-13.51-13.55-.04-25.99-.04-51.99,0-77.98,.02-9.91,3.67-13.49,13.65-13.5,19.33-.02,38.66,0,57.99,0,1.75,0,3.5,0,5.55,0,0-18.76-.39-36.75,.14-54.71,.35-11.94,.8-24.09,3.26-35.71C90.88,45.14,120.04,14.5,168.75,3.29c6.13-1.41,12.4-2.21,18.6-3.29Z"/></g></svg>
            </CircularButton>

            <style jsx>{`
                svg {
                    fill: white;
                    height: 30px;
                }
            `}</style>
        </SmartLinkExternal>

    )
})


export default ShareFacebookLink